import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as CheckCircleIcon } from './checkCircle.svg';

export const CheckCircle = IconHOC(CheckCircleIcon);
